import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// DS
import {
  Col,
  VertTypography,
  Row,
  VertCheckbox,
  VertLoading,
  VertInput,
  VertTooltip,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Checkout/PaymentScoreMoreMoneyStyles.less';
import FormsMethodPayment from 'components/Forms/FormsMethodPayment';
import { useSelector } from 'react-redux';
import { convertNumberToStrCurrency } from 'Utils/convertPoints';
import generateUUID from 'Utils/generateUUID';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';
import { formatToNumber } from 'Utils/format';
import TitleTooltipHelp from './components/titleTooltipHelp';
import { pointsMask } from 'Utils/commons/points';
import {useCheckoutProvider} from "components/Checkout/CheckoutProvider";

// PAYMENT POINTS MORE MONEY COMPONENT
const PaymentScoreMoreMoney = ({ ...props }) => {
  const { pointsValue, handleCheckoutInfos } = props;
  const { setCredicard, handleUsedPointsChange } = useCheckoutProvider();

  const PaymentConfig = useSelector(({ PaymentConfig: data }) => data);
  const { paymentConfig: PointsAndCashConfig } = PaymentConfig;
  const { minPointForCash, maxPointForCash } = PointsAndCashConfig;

  /* HOOKS */
  
  const [pointsUsed, setPointsUsed] = useState(minPointForCash);
  const [totalToPay, setAmountPay] = useState(0);
  const [useTotalScore, setUseTotalScore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(null);

  const PaymentInstallments = useSelector(
    ({ PaymentInstallments: data }) => data
  );

  const Catalog = useSelector(({ Catalog: data }) => data);
  const {
    currencyConfiguration: { decimalPlaces, pointsName },
  } = Catalog;

  const { callApi } = usePipeContext();

  useEffect(() => {
    if (
      PaymentInstallments?.finishRequests &&
      PaymentInstallments?.isError === false
    ) {
      const amountToPay = PaymentInstallments?.paymentInstallments[0] || {};
      const value = convertNumberToStrCurrency(
        amountToPay?.parcelValue || 0,
        2
      );
      setAmountPay(value);
    }
  }, [PaymentInstallments?.finishRequests]);

  useEffect(() => {
    setLoading(PaymentInstallments?.isLoading);
  }, [PaymentInstallments?.isLoading]);

  useEffect(() => {
    //quando a escolha mudar
    if (!PaymentConfig?.isLoading && PaymentConfig?.finishRequests) {
      const { totalOrder } = PointsAndCashConfig;
      if (pointsUsed > 0) {
        let pointsUsedChecked = pointsUsed;
        let modifiedPoints = false;
        if (minPointForCash > pointsUsed) {
          pointsUsedChecked = minPointForCash;
          modifiedPoints = true;
        }
        if (maxPointForCash < pointsUsed) {
          pointsUsedChecked = maxPointForCash;
          modifiedPoints = true;
        }
        if (modifiedPoints) {
          handleUsedPointsChange(pointsUsedChecked);
          setPointsUsed(pointsUsedChecked);
        }

        const pointsDiff =
          maxPointForCash - pointsUsedChecked < 0
            ? totalOrder - maxPointForCash
            : totalOrder - pointsUsedChecked;

        setTimeout(() => {
          handleCheckoutInfos({
            pointsSelected: pointsUsed,
          });
        }, 300);
        callApi({
          symbol: 'FETCH_POINTS_CASH_INSTALLMENTS',
          alias: generateUUID(),
          payload: {
            PointsCash: pointsDiff,
          },
        });
      } else {
        setTimeout(() => {
          handleCheckoutInfos({
            pointsSelected: 0,
          });
        }, 300);
      }
    }
  }, [pointsUsed]);

  useEffect(() => {
    if (useTotalScore) {
      setPointsUsed(formatToNumber(pointsValue.toString()));
    }
  }, [useTotalScore]);

  /* HANDLES */
  const handleInputChange = (event) => {
    const inputValue = event?.target?.value;
    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      if (!isNaN(formatToNumber(inputValue))) {
        setCredicard({pointsUsed: formatToNumber(inputValue)})
        setPointsUsed(formatToNumber(inputValue));
        handleUsedPointsChange(formatToNumber(inputValue));
      } else {
        setCredicard({pointsUsed: 0})
        setPointsUsed(0);
      }
    }, 1000);
    setTimer(newTimer);
  };

  const handleUseTotalScore = () => {
    setUseTotalScore(!useTotalScore);
  };

  let inputProps = loading
    ? {
      suffix: <VertLoading type={'spin'} color="var(--color-detached)" size={'small'} />,
      }
    : {};

  const formattedMaxPointForCash = pointsMask(
    maxPointForCash,
    decimalPlaces,
    pointsName
  );

  const formattedMinPointForCash = pointsMask(
    minPointForCash,
    decimalPlaces,
    pointsName
  );

  return (
    <Col className="payment-scoreMoney-wrapper col-12 col-md-auto">
      <Col className="checkout-payment-title margin-bottom-small">
        <VertTypography.Title>Defina seus valores</VertTypography.Title>
      </Col>
      <Col className="checkout-payment-content margin-bottom-small">
        <Row>
          <VertTypography.Paragraph>
            O mínimo de pontos permitidos é {formattedMinPointForCash.value} {pointsName} e o máximo é {formattedMaxPointForCash.value} {pointsName}.
          </VertTypography.Paragraph>
        </Row>
      </Col>
      <Col className="payment-scoreMoney-content col-12 col-sm-10">
        <Row className="payment-scoreMoney-amountToPay">
          <Col className="col-12 col-sm-6 margin-bottom-small">
            <Row>
              <TitleTooltipHelp
                title="Pontos Utilizados"
                tooltipHelperText={`Aqui você consegue estabelecer a quantidade de pontos que deseja utilizar para o resgate.`}
                sizeTitleTooltip="small"
              />
              <VertInput
                value={pointsUsed.toString()}
                onChange={(target) => handleInputChange(target)}
                className="payment-scoreMoney-inputBold"
                disabled={useTotalScore || loading}
                {...inputProps}
              />
            </Row>
            <Row className="margin-top-extra-small margin-bottom-extra-small">
              <VertCheckbox
                value={!useTotalScore}
                checked={useTotalScore}
                onChange={handleUseTotalScore}
                template="marketplace"
                style={{
                  backgroundColor: 'var(--color-datached) !important',
                }}
              >
                Usar o valor máximo em pontos
              </VertCheckbox>
            </Row>
          </Col>
          <Col className="col-12 col-sm-6 margin-bottom-small">
            <TitleTooltipHelp
              title="Valor a Pagar"
              tooltipHelperText="Neste campo é mostrado o valor que você irá pagar em dinheiro,
                baseado na soma de seu saldo de pontos. Esse campo não é editável."
              sizeTitleTooltip="medium"
            />

            <VertInput
              value={`R$ ${totalToPay}`}
              className="payment-scoreMoney-inputBold"
              disabled={true}
              {...inputProps}
            />
          </Col>
        </Row>
        <Row>
          <FormsMethodPayment
            loading={loading}
            handleCheckoutInfos={handleCheckoutInfos}
            pointsSelected={pointsUsed}
            cashSelected={`R$ ${totalToPay}`}
          />
        </Row>
      </Col>
    </Col>
  );
};

PaymentScoreMoreMoney.propTypes = {
  pointsValue: PropTypes.number,
  handleCheckoutInfos: PropTypes.func.isRequired,
};


export default PaymentScoreMoreMoney;
